const rawAliasMap = process.env.VUE_APP_BRAND_ID_ALIAS_MAP;

function buildAliasLookup(raw) {
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    const lookup = {};

    Object.keys(parsed || {}).forEach((key) => {
      const value = parsed[key];

      if (Array.isArray(value)) {
        value.forEach((alias) => {
          if (typeof alias === 'string' && alias.trim()) {
            lookup[alias] = key;
          }
        });
      } else if (typeof value === 'string' && value.trim()) {
        // Supports reverse map: { "SB3": "SB2" }
        lookup[key] = value;
      }
    });

    return lookup;
  } catch (e) {
    console.error('Failed to parse VUE_APP_BRAND_ID_ALIAS_MAP:', e);
    return {};
  }
}

const aliasLookup = buildAliasLookup(rawAliasMap);

export function normalizeBrandId(brandId) {
  if (!brandId) return brandId;
  return aliasLookup[brandId] || brandId;
}

